import React from 'react';

import { ReactComponent as PencilWrite } from '../../../assets/icons/PencilWrite.svg';
import Button from '../Button/Button';

import classes from './ButtonEdit.module.scss';

const ButtonEdit = ({ name, onClick, textModule }) => {
  return (
    <Button Icon={PencilWrite} custom='quaternary' name={name} onClick={onClick}>
      <div>
        Editar <span className={classes.text}>{textModule}</span>
      </div>
    </Button>
  );
};

export default ButtonEdit;
